import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-label text-primary-400 uppercase tracking-widest mb-3">
            常见问题
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-50 mb-4">
            快速了解
          </h2>
          <p className="text-foreground-400 text-sm leading-relaxed">
            关于「邪娠娼馆」世界观指南的常见疑问
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-200/70 border border-background-300/40 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-label font-medium text-foreground-200 pr-4">
                  {item.question}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-${
                      openIndex === idx ? 'subtract' : 'add'
                    }-line text-lg text-primary-400 transition-transform duration-300`}
                  ></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-5 text-sm text-foreground-400 leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}